.wrap { display: flex; flex-direction: column; height: 100%; min-height: 0; }

.head {
  display: flex; align-items: flex-start; gap: var(--sp-3);
  padding: var(--sp-4) var(--sp-4) var(--sp-3);
  border-bottom: 1px solid var(--hair);
}
.titles { flex: 1; min-width: 0; }
.title { margin: 0; font-size: var(--fs-md); font-weight: 640; letter-spacing: -0.015em; }
.sub { margin: var(--sp-0-5) 0 0; font-size: var(--fs-xs); color: var(--muted); }
.sub strong { color: var(--ink); font-weight: 620; }

/* Same 26px square as RecordRelations' ⌘, so the two read as one control in two
   places rather than two controls that happen to share a glyph. */
.cmd {
  flex: none; width: 26px; height: 26px; margin-top: 1px;
  border-radius: var(--r-sm); border: 1px solid var(--hair);
  background: var(--surface); color: var(--muted);
  cursor: pointer; font-size: 12px; line-height: 1;
}
.cmd:hover { color: var(--ink); border-color: var(--brand); }

.icon {
  flex: none; width: 24px; height: 24px; margin-top: 1px;
  border-radius: var(--r-sm); border: 1px solid transparent;
  background: transparent; color: var(--muted);
  cursor: pointer; font-size: 12px; line-height: 1;
}
.icon:hover { color: var(--ink); border-color: var(--border); }

.note {
  margin: 0; padding: var(--sp-3) var(--sp-4) 0;
  font-size: var(--fs-xs); color: var(--muted);
}
.inline {
  border: 0; background: none; padding: 0; cursor: pointer;
  color: var(--brand-text); font: inherit; text-decoration: underline;
}

.error {
  margin: var(--sp-3) var(--sp-4) 0; padding: var(--sp-3);
  border-radius: var(--r-sm); border: 1px solid var(--crit, #c2453d);
  color: var(--crit, #c2453d); font-size: var(--fs-sm);
}

.review {
  margin: var(--sp-3) var(--sp-4) 0; padding: var(--sp-3);
  border: 1px solid var(--warn); border-radius: var(--r-sm);
  background: var(--warn-bg); color: var(--ink);
}
.review h4 { margin: 0; font-size: var(--fs-sm); }
.review p { margin: var(--sp-1) 0 var(--sp-3); color: var(--muted); font-size: var(--fs-xs); }
.candidates { display: grid; gap: var(--sp-2); }
.candidate {
  display: grid; gap: var(--sp-0-5); width: 100%; padding: var(--sp-2) var(--sp-3);
  border: 1px solid var(--hair); border-radius: var(--r-sm);
  background: var(--surface); color: var(--ink); text-align: left; cursor: pointer;
}
.candidate:hover { border-color: var(--brand); }
.candidate strong { font-size: var(--fs-sm); }
.candidate span { color: var(--muted); font-size: var(--fs-xs); }
.createAnyway {
  margin-top: var(--sp-3); padding: 0; border: 0; background: transparent;
  color: var(--muted); font: inherit; font-size: var(--fs-xs); text-decoration: underline; cursor: pointer;
}
.createAnyway:hover { color: var(--ink); }

.body { flex: 1; min-height: 0; overflow-y: auto; padding: var(--sp-4); }

.empty {
  display: flex; flex-direction: column; align-items: center; justify-content: center;
  gap: var(--sp-3); height: 100%; padding: var(--sp-6);
  color: var(--muted); font-size: 1.5rem; text-align: center;
}
.empty p { margin: 0; font-size: var(--fs-sm); max-width: 26ch; }
